import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap5';

export default function WithTooltip({ content }) {
  const renderTooltip = (props) => <Tooltip {...props}>{content}</Tooltip>;

  return (
    <OverlayTrigger overlay={renderTooltip}>
      <>{content}</>
    </OverlayTrigger>
  );
}

WithTooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};
